import _get from 'lodash/get';
import _isNil from 'lodash/isNil';

function getSafeWindow(referenceWindow) {
  let finalWindow = referenceWindow;

  if (typeof window !== 'undefined' && _isNil(finalWindow)) {
    finalWindow = window;
  }

  return finalWindow;
}

class DimensionUtils {
  static getFromReactReference(reactReference) {
    const current = _get(reactReference, 'current');

    if (current) {
      if (current.getBoundingClientRect) {
        return current.getBoundingClientRect();
      }
      const currentRef = _get(current, 'ref.current');
      if (currentRef && currentRef.getBoundingClientRect) {
        return currentRef.getBoundingClientRect();
      }
    }
    return {};
  }

  static getRelativeDistanceToWindowBorders(
    reactReference,
    { thresholdPercentage = 0.25, referenceWindow } = {},
  ) {
    const finalWindow = getSafeWindow(referenceWindow);

    const dimensions = this.getFromReactReference(reactReference);
    const windowDimensions = this.getWindowDimensions({ referenceWindow: finalWindow });

    const leftPercentage = dimensions.left / windowDimensions.width;
    const rightPercentage = 1 - dimensions.right / windowDimensions.width;

    return {
      tooCloseToLeft: leftPercentage < thresholdPercentage,
      tooCloseToRight: rightPercentage < thresholdPercentage,
      leftPercentage,
      rightPercentage,
    };
  }

  static getWindowDimensions({ referenceWindow } = {}) {
    const finalWindow = getSafeWindow(referenceWindow);

    if (!_isNil(finalWindow)) {
      return {
        width: finalWindow.screen.width,
        height: finalWindow.screen.height,
      };
    }
    return { width: 0, height: 0 };
  }
}

export default DimensionUtils;
